import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then((m) => m.RegisterPageModule),
  },

  {
    path: 'magic-link',
    loadChildren: () => import('./magic-link/magic-link.module').then((m) => m.MagicLinkModule),
  },
  {
    path: 'token',
    loadChildren: () => import('./verify-token/verify-token.module').then((m) => m.VerifyTokenPageModule),
  },
  {
    path: 'auth_tokens/:token',
    redirectTo: 'token/:token',
  },
  {
    path: 'referral-login',
    loadChildren: () => import('./referral-login/referral-login.module').then((m) => m.ReferralLoginModule),
  },
  { path: 'accept_survivor_invitation/:token', redirectTo: 'referral-login/:token' },
];
